import React from "react";
import Routers from "./Routers";
import AuthenticateProvider from "./Context/AuthenticateProvider";
import { ToastContainer } from "react-toastify";
import Loader from "./Partials/Loader";

const App = () => {
  return (
    <React.Fragment>
      {/* <Loader /> */}
      <AuthenticateProvider>
        <Routers />
      </AuthenticateProvider>
      <ToastContainer theme="light" toastStyle={{ textTransform: 'capitalize' }} autoClose={2000} position="top-right" />
    </React.Fragment>
  )
}

export default App


